import React from 'react';
import { MineCustomDataProvider } from './context/mineCustomDataProvider';
import MineIndex from '../components/mine/mineindex';

import '../assets/css/mine.css'

const Mine: React.FC = () => {

    return (
        <MineCustomDataProvider>
            <MineIndex/>
        </MineCustomDataProvider>
    )

};

export default Mine;
